











import {ChartDataTemplate, WConfTpl, WidgetDefinition} from '@/components/widgets/WidgetFather'
import {defineComponent, reactive} from "@vue/composition-api"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"
import {getTitle} from "@/components/widgets/hd/hdCommon"
import {executeQuery} from "@/data/repos/query"
import {bus} from "@/main"

export function config(): WidgetDefinition {
    return {
      ...WConfTpl.Custom(),
      widget: "HDJobsForYearToDate",
      title: "Jobs for year to date",
      cType: "stackedcolumn2d",
      params: {},
    }
  }

  export async function dataFetcher(params: any) {
    const year = new Date().getFullYear()
    return {
      ...await executeQuery(
        'FMS_DB',
        'jobsForYearRepair',
        {year}, filter),
    }
  }

  function filter(data: any): any {
    const categories = [{category: [] as any}]
    const dataset = [
      {"seriesName": "Completed", "color": "#6BAA01", "data": [] as any},
      {"seriesName": "Outstanding", "color": "#DC143C", "data": [] as any},
    ]
    data.forEach((item: any) => {
      item.Status === "Completed" && categories[0].category.push({label: item.Label})
      dataset[item.Status === "Completed" ? 0 : 1].data.push({value: item.Value + ""})
    })
    return {categories, dataset}
  }

  function getChartDataConfig() {
    return reactive({
        ...ChartDataTemplate(),
        showLabels: "1",
        valueFontColor: "#EEE",
        xAxisName: "Month",
        rotateLabels: "0",
      },
    )
  }

  async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
    config && (chartDataConfig.subCaption = getTitle(config.params))
  }

  function chartDSTemplate() { // required if FC data not in {data: {}} format
    return {
      categories: [],
      dataset: [],
    }
  }

  export default defineComponent({
    props: {config: Object},
    components: {FusionChartWidget},
    setup(props, context) {
      context.emit("config-update", config())

      function dataplotClickCallback(label: string, val: string) {
        if (!label) {
          return
        }
        const month = new Date(Date.parse(label + " 1, 2035")).getMonth() + 1
        const year = new Date().getFullYear()
        const monthName = new Date(Date.parse(label + " 1, 2035")).toLocaleString('default', {month: 'long'})
        bus.$emit('chartPopup', {
          title: `Jobs for ${monthName} ${year}`,
          component: () => import('@/components/drilldowns/JobsRaisedDrillDown.vue'),
          componentArgs: {hdPPMRepairAll: 2, jobCategory: 0, day: 0, month, year},
        })
      }

      return {dataFetcher, getChartDataConfig, configChangeCallback, dataplotClickCallback, chartDSTemplate}
    },
  })
